import script from "./PreSportsCompetition.vue?vue&type=script&setup=true&lang=js"
export * from "./PreSportsCompetition.vue?vue&type=script&setup=true&lang=js"

import "./PreSportsCompetition.vue?vue&type=style&index=0&id=5890ced4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5890ced4"]])

export default __exports__